import { getChannelClient } from 'src/utils/messages/singleton'
import { getAbandonedCart } from 'src/widgets/embed/abandonedCart'

// Thin layer for the donate widget to announce engagement signals
// to the abandoned-cart manager, wherever it lives.
//
//   - Mode 1 — donate widget at top level (parent === self): the
//     donate-widget pack bootstraps a local manager
//     (standaloneAbandonedCart.js). getAbandonedCart() returns it and
//     we call its setters directly — no channel hop.
//   - Modes 2 + 3 — donate widget in an iframe: no local manager;
//     announcements go over the channel to the embed script's
//     manager.
//
// Routing is decided at call time, not at module-load time, since
// the manager is set up in module-load order (the donate-widget
// pack's side-effect import) and this file may be imported before
// that runs.

export const announceEngagement = payload => {
  const local = getAbandonedCart()
  if (local) return local.setEngagement(payload)
  if (parent === self) return  // mode 1 but no manager — silent no-op
  getChannelClient().send('donorEngagementChanged', payload)
}

export const announceFormState = patch => {
  const local = getAbandonedCart()
  if (local) return local.setFormState(patch)
  if (parent === self) return
  getChannelClient().send('donorFormStateChanged', patch)
}

export const announceDonationCompleted = () => {
  const local = getAbandonedCart()
  if (local) return local.onDonationCompleted()
  if (parent === self) return
  getChannelClient().send('donationCompleted')
}
